import { render, staticRenderFns } from "./RecursiveHelpAnswers.vue?vue&type=template&id=86e6252c&scoped=true"
import script from "./RecursiveHelpAnswers.vue?vue&type=script&lang=js"
export * from "./RecursiveHelpAnswers.vue?vue&type=script&lang=js"
import style0 from "./RecursiveHelpAnswers.vue?vue&type=style&index=0&id=86e6252c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e6252c",
  null
  
)

export default component.exports